import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import TabHeader from './tab-header';

import { fetchDomainsOverviewIfNeeded } from '../../common/actions/domains-overview-action-creators';
import {
    claimedDomainsOverviewSelector,
    discoveredDomainsOverviewSelector
} from '../../common/selectors/domains-overview-selectors';

export const TabHeaderContainer = ( {
    claimedOverviewData, discoveredOverviewData, fetchDomainsOverviewIfNeeded, type
} ) => {
    useEffect( () => {
        fetchDomainsOverviewIfNeeded();
    }, [fetchDomainsOverviewIfNeeded] );

    const overviewDataMap = {
        claimed: claimedOverviewData,
        discovered: discoveredOverviewData
    };

    return (
        <TabHeader data={overviewDataMap[type]} type={type} />
    );
};

/* istanbul ignore next */
const mapStateToProps = ( state ) => ( {
    claimedOverviewData: claimedDomainsOverviewSelector( state ),
    discoveredOverviewData: discoveredDomainsOverviewSelector( state )
} );

TabHeaderContainer.propTypes = {
    claimedOverviewData: PropTypes.shape( {
        parentDomains: PropTypes.shape( {
            totalCount: PropTypes.number
        } ),
        subdomains: PropTypes.shape( {
            totalCount: PropTypes.number
        } ),
        totalCount: PropTypes.number,
    } ),
    discoveredOverviewData: PropTypes.shape( {
        parentDomains: PropTypes.shape( {
            totalCount: PropTypes.number
        } ),
        subdomains: PropTypes.shape( {
            totalCount: PropTypes.number
        } ),
        totalCount: PropTypes.number,
    } ),
    fetchDomainsOverviewIfNeeded: PropTypes.func.isRequired,
    type: PropTypes.oneOf( ['claimed', 'discovered'] ).isRequired,
};


export default connect( mapStateToProps, { fetchDomainsOverviewIfNeeded } )( TabHeaderContainer );
